import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'handoverm-handover-limited-access-modal',
  templateUrl: './handover-limited-access-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HandoverLimitedAccessModalComponent implements OnInit {

  constructor(
    private matDialogRef: MatDialogRef<HandoverLimitedAccessModalComponent>,
  ) {
  }

  ngOnInit(): void {
  }

  onContact() {
    this.matDialogRef.close();
  }

  onClose() {
    this.matDialogRef.close();
  }
}
